// extracted by mini-css-extract-plugin
export default {"container":"CheckNewsletterPopup_container__Lvcfb","title":"CheckNewsletterPopup_title__6JAqx","buttonContainer":"CheckNewsletterPopup_buttonContainer__5qVqI"};